import {LiveEventScheduledNotification} from "./LiveEventScheduledNotification";
import {DefaultNotification} from "./DefaultNotification";
import {NewMasterclassCommentNotification} from "./NewMasterclassCommentNotification";
import {Link} from "react-router-dom";
import {NewMemberDiscussionCommentNotification} from "./NewMemberDiscussionCommentNotification";
import {CommentReplyNotification} from "./CommentReplyNotification";

export const NotificationContent = ({ notification, style }) => {

    if (notification.entities.length === 0) {
        return <DefaultNotification notification={notification}/>
    }

    return (
        <div className="notification__content" style={style}>
            <div className="notification__content__heading">
                {notification.sender &&
                    <div>
                        <Link className="notification__content__heading__name" to={`/community/users/${notification.sender?.id}`}>
                            {notification.sender?.name}
                        </Link>
                    </div>
                }
                <div className="notification__content__heading__time">
                    {notification.created_at}
                </div>
            </div>
            <div className="notification__content__data">
                {(() => {

                    switch (notification.type) {
                        case 'live-event':
                            return <LiveEventScheduledNotification
                                notification={notification}
                            />;
                        case 'masterclass-comment':
                            return <NewMasterclassCommentNotification
                                notification={notification}
                            />;
                        case 'member-discussion-comment':
                            return <NewMemberDiscussionCommentNotification
                                notification={notification}
                            />;
                        case 'comment-reply':
                            return <CommentReplyNotification
                                notification={notification}
                            />;
                        default:
                            return <></>;
                    }

                })()}
            </div>
        </div>
    );
};